import React from "react";
import PropTypes from "prop-types";
import ShotClockQueueModal from "../../ShotClock/ShotClockQueueModal/ShotClockQueueModal";
import RejectOfferModal from "../../OfferBoards/RejectOfferModal/RejectOfferModal";
import CarrierProfileCapacityExpireModal from "../../CarrierProfile/CarrierProfileCapacityExpireModal/CarrierProfileCapacityExpireModal";
import CarrierProfileContactsDeleteModal from "../../CarrierProfile/CarrierProfileContacts/CarrierProfileContactsDeleteModal/CarrierProfileContactsDeleteModal";

export default function TableModalContainer({
  activeTableModal,
  setActiveTableModal,
  setRefreshPage,
  setRefreshLoads
}) {
  return (
    <>
      {activeTableModal?.action === "shot-clock-locked" &&
        <ShotClockQueueModal
          isOpen={activeTableModal?.action === "shot-clock-locked"}
          setIsOpen={setActiveTableModal}
          load={activeTableModal?.load}
          expirationTime={activeTableModal?.expirationTime}
          loadLocked={activeTableModal?.loadLocked}
        />
      }
      {activeTableModal?.action === "reject-offer" &&
        <RejectOfferModal
          open={activeTableModal?.action === "reject-offer"}
          setOpen={setActiveTableModal}
          offersRejected={activeTableModal?.offersRejected}
          previousOffers={activeTableModal?.previousOffers}
          newOffersCount={activeTableModal?.newOffersCount}
          isManager={activeTableModal?.isManager}
          setRefreshPage={setRefreshPage}
          setRefreshLoads={setRefreshLoads}
        />
      }
      {activeTableModal?.action === "expire-capacity" &&
        <CarrierProfileCapacityExpireModal
          open={activeTableModal?.action === "expire-capacity"}
          setOpen={setActiveTableModal}
          userIdMcld={activeTableModal?.userIdMcld}
          capacityType={activeTableModal?.originPoint}
          selectedLanes={activeTableModal?.selectedLanes}
          setRefreshPage={setRefreshPage}
        />
      }
      {activeTableModal?.action === "delete-carrier-contact" &&
        <CarrierProfileContactsDeleteModal
          open={activeTableModal?.action === "delete-carrier-contact"}
          setOpen={setActiveTableModal}
          contact={activeTableModal?.contact}
          contactDeleted={activeTableModal?.contactUpdated}
        />
      }
    </>
  );
}

TableModalContainer.propTypes = {
  activeTableModal: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.bool
  ]),
  setActiveTableModal: PropTypes.func.isRequired,
  setRefreshPage: PropTypes.func,
  setRefreshLoads: PropTypes.func
};